import { render, staticRenderFns } from "./QuestionBlank.vue?vue&type=template&id=5a9a97b2&scoped=true&"
import script from "./QuestionBlank.vue?vue&type=script&lang=js&"
export * from "./QuestionBlank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBlank.vue?vue&type=style&index=0&id=5a9a97b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a97b2",
  null
  
)

export default component.exports